import { render, staticRenderFns } from "./RoomInput.vue?vue&type=template&id=4f6e22be"
import script from "./RoomInput.vue?vue&type=script&lang=js"
export * from "./RoomInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports